// extracted by mini-css-extract-plugin
export default {"media":"VLoz8DX---styles_media__en1RF","dialog":"VLoz8DX---styles_dialog__RivB6","fab":"VLoz8DX---styles_fab__KzymK","mediaButton":"VLoz8DX---styles_mediaButton__Zleee"};